import getSpecialProducts, {
  ResGetSpecialProducts,
} from '@/service/market/special/getSpecialProducts';
import { useQuery } from '@tanstack/react-query';
import { RQSpecialKey } from './RQSpecialKey';

const useSpecialProductsHomeQuery = () => {
  return useQuery<
    ResGetSpecialProducts,
    object,
    ResGetSpecialProducts['result']['content'],
    (typeof RQSpecialKey)['specialHomeProducts']
  >({
    queryKey: RQSpecialKey['specialHomeProducts'],
    queryFn: () => getSpecialProducts({ query: {} }),
    select: (data) => {
      return data.result.content.slice(0, 8);
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useSpecialProductsHomeQuery;
